import React from 'react';

const LocationMap: React.FC = () => {
    const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.542882561984!2d-99.2650252882726!3d19.039854282082896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cde1a8591cf9a3%3A0x37a3ca73e0cb618e!2sCoraz%C3%B3n%20de%20Monta%C3%B1a%20(Feudo%20de%20Caza)!5e0!3m2!1ses!2smx!4v1757478523938!5m2!1ses!2smx";
    return (
        <div>
            <div className="relative w-full h-[336px] rounded-[70px] shadow-lg overflow-hidden">
                <iframe
                    src={mapSrc}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Event Location"
                ></iframe>
                <div
                    className= {`absolute top-0 left-0 w-full h-full pointer-events-none bg-[#1e2b3f] mix-blend-color`}
                ></div>
            </div>
        </div>
    );
};

export default LocationMap;